import './story.css'
import Card from '../components/cardStory';
import Talk from '../components/talk';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function Story(){
    const [stories, setStory]=useState([])

    useEffect(()=>{
        const fetchData=async()=>{
            try{
                const response = await axios.get(`${process.env.React_APP_API_URL}/api/v1/story`);
                if(response.status===200){
                    setStory(response.data)
                }
            }catch(err) {
                console.log(err)
            }
        }
        fetchData()
    },[])

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
          window.scrollTo(0, 0);
        };
      }, []); 
    
    return(
        <>
            <div className='productBanner'>
                <img src='./images/prodDummyBanner.png' alt=''/>
            </div>
            <div className='storyWrapper'>
                <div className='storyList'>
                    {stories.map((item, key)=>{
                        return<Card item={item} key={key}/>
                    })}
                </div>
                <div className='contactUS estTAlk'>
                    <Talk/>
                </div>
            </div>
        </>
    );
}